module.exports = __webpack_public_path__ + "static/img/logo-ecole-negatif.2fbe9287.png";